import type { GetRoadsInput } from './dtos/models';
import type { Road } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RoadService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getByInput = (input: GetRoadsInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Road[]>({
      method: 'GET',
      url: '/api/app/road',
      params: { supervisorIds: input.supervisorIds },
    },
    { apiName: this.apiName,...config });
}